// creates a unique id to use for the keys when iterating 
export function uniqueId(): string{
    return Date.now().toString(36)+Math.random().toString(36).substring(2,5)+Math.random().toString(36).substring(2,4);
}